import {
  Component,
  HostBinding,
  OnInit,
  OnDestroy,
  Inject
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  WebsocketGatewayService,
  EnvironmentConfig,
  ENVIRONMENT_CONFIG
} from '@ipreo/northstar';
import {
  getLiveState,
  getMarketsDataState,
  getMarketsSelectedState,
  MarketDrawerRootReducerState
} from '../../../state/reducer';
import {
  MarketsLoadSuccessAction,
  SelectedMarketChangedAction
} from '../../../state/markets/actions';
import { MarketView, Markets } from '../../../models/markets';
import { MarketsService } from '../../../services/markets.service';

@Component({
  selector: 'muni-gameday-market-drawer-markets',
  templateUrl: './markets.template.html',
  styleUrls: ['./markets.styles.scss'],
  standalone: false,
})
export class MarketsComponent implements OnInit, OnDestroy {
  @HostBinding('class.marketDrawerSection')
  public section = true;

  public readonly data: Observable<Markets> = this.store.pipe(
    select(getMarketsDataState),
    distinctUntilChanged()
  );
  public readonly live: Observable<boolean> = this.store.pipe(
    select(getLiveState),
    distinctUntilChanged()
  );
  public readonly selected: Observable<MarketView> = this.store.pipe(
    select(getMarketsSelectedState),
    distinctUntilChanged()
  );

  private liveSubscription: Subscription;
  private env: string;

  constructor(
    private wsgService: WebsocketGatewayService,
    private store: Store<MarketDrawerRootReducerState>,
    private marketsService: MarketsService,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.env = config.northstar.env;
  }

  public ngOnInit(): void {
    this.connectToChannel();
  }

  public ngOnDestroy(): void {
    this.liveSubscription.unsubscribe();
  }

  public marketChanged(market: MarketView): void {
    this.store.dispatch(new SelectedMarketChangedAction(market));
  }

  private connectToChannel(): void {
    this.liveSubscription = this.wsgService
      .subscribe(`munis-equities-ticks-${this.env}`)
      .subscribe((event: any) => {
        const ticks = this.marketsService.equitiesToViewModel(event.ticks);
        this.store.dispatch(new MarketsLoadSuccessAction(ticks));
      });
  }
}
